import { Option } from 'commander';
import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { SharedOptions } from '../../types/SharedOptions.js';

const hideSharedOptions: Array<keyof SharedOptions> = ['cachePath', 'features', 'config'];

/** Defines the "info" verb. */
export const init: CommandInitFunction = (program) => {
  const infoCommand = program.addSubCommand({
    name: 'info',
    description: 'Get repo info relevant to Cloudpack (requires a sub-command).',
    usage: '<command>',
    hideSharedOptions: true,
  });

  infoCommand.addSubCommand({
    name: 'lock-file',
    alias: 'lockfile',
    description: 'Get info about potentially problematic deps from the lock file (yarn v1 only).',
    hideSharedOptions,
    getExecutor: () => import('./lockFile/execute.js'),
  });

  infoCommand.addSubCommand({
    name: 'non-semver-deps',
    description: 'Get a list of non-semver deps from local packages.',
    getExecutor: () => import('./nonSemverDeps/execute.js'),
    hideSharedOptions,
    options: {
      prod: new Option('--prod', 'Only get production deps'),
    },
  });
};
